import { __decorate } from 'tslib';
import { PlatformModule } from '@angular/cdk/platform';
import * as i0 from '@angular/core';
import { EventEmitter, numberAttribute, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i1 from 'ng-zorro-antd/core/config';
import { WithConfig } from 'ng-zorro-antd/core/config';
import * as i2 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
const _c0 = ["textEl"];
function NzAvatarComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("nzType", ctx_r0.nzIcon);
  }
}
function NzAvatarComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 4);
    i0.ɵɵlistener("error", function NzAvatarComponent_Conditional_1_Template_img_error_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.imgError($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.nzSrc, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("srcset", ctx_r0.nzSrcSet)("alt", ctx_r0.nzAlt);
  }
}
function NzAvatarComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3, 0);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.nzText);
  }
}
const _c1 = ["*"];
const NZ_CONFIG_MODULE_NAME = 'avatar';
let NzAvatarComponent = /*#__PURE__*/(() => {
  class NzAvatarComponent {
    constructor(nzConfigService, elementRef, cdr) {
      this.nzConfigService = nzConfigService;
      this.elementRef = elementRef;
      this.cdr = cdr;
      this._nzModuleName = NZ_CONFIG_MODULE_NAME;
      this.nzShape = 'circle';
      this.nzSize = 'default';
      this.nzGap = 4;
      this.nzError = new EventEmitter();
      this.hasText = false;
      this.hasSrc = true;
      this.hasIcon = false;
      this.classMap = {};
      this.customSize = null;
      this.el = this.elementRef.nativeElement;
    }
    imgError($event) {
      this.nzError.emit($event);
      if (!$event.defaultPrevented) {
        this.hasSrc = false;
        this.hasIcon = false;
        this.hasText = false;
        if (this.nzIcon) {
          this.hasIcon = true;
        } else if (this.nzText) {
          this.hasText = true;
        }
        this.cdr.detectChanges();
        this.setSizeStyle();
        this.calcStringSize();
      }
    }
    ngOnChanges() {
      this.hasText = !this.nzSrc && !!this.nzText;
      this.hasIcon = !this.nzSrc && !!this.nzIcon;
      this.hasSrc = !!this.nzSrc;
      this.setSizeStyle();
      this.calcStringSize();
    }
    ngAfterViewInit() {
      this.calcStringSize();
    }
    calcStringSize() {
      if (!this.hasText || !this.textEl) {
        return;
      }
      const textEl = this.textEl.nativeElement;
      const childrenWidth = textEl.offsetWidth;
      const avatarWidth = this.el.getBoundingClientRect?.().width ?? 0;
      const offset = this.nzGap * 2 < avatarWidth ? this.nzGap * 2 : 8;
      const scale = avatarWidth - offset < childrenWidth ? (avatarWidth - offset) / childrenWidth : 1;
      textEl.style.transform = `scale(${scale}) translateX(-50%)`;
      textEl.style.lineHeight = this.customSize || '';
    }
    setSizeStyle() {
      if (typeof this.nzSize === 'number') {
        this.customSize = `${this.nzSize}px`;
      } else {
        this.customSize = null;
      }
      this.cdr.markForCheck();
    }
    static {
      this.ɵfac = function NzAvatarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzAvatarComponent)(i0.ɵɵdirectiveInject(i1.NzConfigService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzAvatarComponent,
        selectors: [["nz-avatar"]],
        viewQuery: function NzAvatarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textEl = _t.first);
          }
        },
        hostAttrs: [1, "ant-avatar"],
        hostVars: 20,
        hostBindings: function NzAvatarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.customSize)("height", ctx.customSize)("line-height", ctx.customSize)("font-size", ctx.hasIcon && ctx.customSize ? ctx.nzSize / 2 : null, "px");
            i0.ɵɵclassProp("ant-avatar-lg", ctx.nzSize === "large")("ant-avatar-sm", ctx.nzSize === "small")("ant-avatar-square", ctx.nzShape === "square")("ant-avatar-circle", ctx.nzShape === "circle")("ant-avatar-icon", ctx.nzIcon)("ant-avatar-image", ctx.hasSrc);
          }
        },
        inputs: {
          nzShape: "nzShape",
          nzSize: "nzSize",
          nzGap: [2, "nzGap", "nzGap", numberAttribute],
          nzText: "nzText",
          nzSrc: "nzSrc",
          nzSrcSet: "nzSrcSet",
          nzAlt: "nzAlt",
          nzIcon: "nzIcon"
        },
        outputs: {
          nzError: "nzError"
        },
        exportAs: ["nzAvatar"],
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 3,
        consts: [["textEl", ""], ["nz-icon", "", 3, "nzType"], [3, "src"], [1, "ant-avatar-string"], [3, "error", "src"]],
        template: function NzAvatarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NzAvatarComponent_Conditional_0_Template, 1, 1, "span", 1)(1, NzAvatarComponent_Conditional_1_Template, 1, 3, "img", 2)(2, NzAvatarComponent_Conditional_2_Template, 3, 1, "span", 3);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.nzIcon && ctx.hasIcon ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.nzSrc && ctx.hasSrc ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.nzText && ctx.hasText ? 2 : -1);
          }
        },
        dependencies: [NzIconModule, i2.NzIconDirective, PlatformModule],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  __decorate([WithConfig()], NzAvatarComponent.prototype, "nzShape", void 0);
  __decorate([WithConfig()], NzAvatarComponent.prototype, "nzSize", void 0);
  __decorate([WithConfig()], NzAvatarComponent.prototype, "nzGap", void 0);
  return NzAvatarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzAvatarGroupComponent = /*#__PURE__*/(() => {
  class NzAvatarGroupComponent {
    static {
      this.ɵfac = function NzAvatarGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzAvatarGroupComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzAvatarGroupComponent,
        selectors: [["nz-avatar-group"]],
        hostAttrs: [1, "ant-avatar-group"],
        exportAs: ["nzAvatarGroup"],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 1,
        vars: 0,
        template: function NzAvatarGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NzAvatarGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzAvatarModule = /*#__PURE__*/(() => {
  class NzAvatarModule {
    static {
      this.ɵfac = function NzAvatarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzAvatarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzAvatarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzAvatarComponent]
      });
    }
  }
  return NzAvatarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzAvatarComponent, NzAvatarGroupComponent, NzAvatarModule };
